"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var react_query_1 = require("@tanstack/react-query");
var networking_1 = require("../networking");
var types_1 = require("../types");
var useParticipateStatus = function (_a) {
    var profileId = _a.profileId, auctionId = _a.auctionId;
    var queryClient = (0, react_query_1.useQueryClient)();
    var _b = (0, networking_1.useValidateRegisteredProfile)({
        profileId: profileId,
        auctionIdList: [auctionId],
    }, { refetchOnMount: false }), registeredProfile = _b.data, registeredProfileIsFetching = _b.isFetching, error = _b.error;
    var _c = (0, react_1.useState)(), participateStatus = _c[0], setParticipateStatus = _c[1];
    var invalidateParticipateStatus = (0, react_1.useCallback)(function () {
        queryClient.invalidateQueries({
            queryKey: [
                types_1.CacheKeys.registrationStatus,
                {
                    profileId: profileId,
                    auctionIdList: [auctionId],
                },
            ],
        });
    }, [queryClient, profileId, auctionId]);
    (0, react_1.useEffect)(function () {
        if (registeredProfile) {
            //Setting the registration object for ParticipateButton
            var tempArr = registeredProfile.filter(function (item) { return item["auctionId"] === auctionId; });
            var reducedArray = tempArr === null || tempArr === void 0 ? void 0 : tempArr.reduce(function (result, item) {
                Object.keys(item).forEach(function (key) {
                    result[key] = item[key];
                });
                return result;
            }, {});
            setParticipateStatus(reducedArray);
        }
        else {
            setParticipateStatus(undefined);
        }
    }, [auctionId, registeredProfile]);
    var loading = registeredProfileIsFetching;
    return {
        participateStatus: participateStatus,
        participateStatusError: error,
        invalidateParticipateStatus: invalidateParticipateStatus,
        loading: loading,
    };
};
exports.default = useParticipateStatus;
